<template>
  <div class="ibox">
    <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
      Show Filters <i class="fa fa-bars"></i>
    </a>
    <div class="ibox-results-filters-collapse-box collapse in">
      <div class="ibox-results-filters">

        <div class="row">
          <div class="col-sm-6 col-lg-6">
            <div class="form-group">
              <label class="control-label">Load Reference or Location</label>
              <input @input="updateKeywords" type="text" class="form-control" placeholder="..." />
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Rego</label>
              <input @input="updateRegistration" type="text" class="form-control" placeholder="..." />
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Status</label>
              <selectize
                :options="statusOptions"
                name="status"
                v-model="status">
              </selectize>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Sort by</label>
              <selectize
                :options="sortByOptions"
                name="sort"
                v-model="sort">
              </selectize>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="ibox-content">

      <ul class="list-detail list-detail-load-breakdown">
        <load-check-list-item v-for="load in loads" :key="load.id" :load="load"></load-check-list-item>

        <li class="text-center text-muted" v-show="haveNoLoadChecks">
          <strong>There are no loads.</strong>
        </li>
      </ul>
    </div>

    <lazy-loading v-show="haveLoadChecks" :reached-bottom="getLoadChecksForNextPage" :filters="filters" ref="lazyLoading">
      <strong slot="finished" class="text-muted">There are no more loads.</strong>
    </lazy-loading>

    <load-check-modal v-if="haveLoad"></load-check-modal>
  </div>
</template>

<script>
  import { LazyLoading } from 'components/misc'
  import { debounce, isEqual } from 'lodash'
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  import { RESET_LOAD, ADD_LOAD, REMOVE_LOAD } from 'vx/mutations'
  import { Selectize } from 'components/forms'
  import LoadCheckListItem from './LoadCheckListItem'
  import LoadCheckModal from './LoadCheckModal'

  export default {
    components: {
      LazyLoading,
      LoadCheckListItem,
      LoadCheckModal,
      Selectize
    },

    data () {
      return {
        keywords: null,
        registration: null,
        status: 'awaiting_approval',
        sort: 'desc'
      }
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

          this.getLoadChecks(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    created () {
      this[RESET_LOAD]()

      this.getLoadChecks(this.filters)

      this.$bus.$on('loadStateUpdated', this.removeLoadIfWeighbridgeApproved)
    },

    beforeDestroy () {
      this.$bus.$off('loadStateUpdated', this.removeLoadIfWeighbridgeApproved)
    },

    computed: {
      ...mapGetters('load', ['haveLoad']),
      ...mapGetters('loadCheck', ['haveLoadChecks', 'haveNoLoadChecks']),
      ...mapState('loadCheck', ['loads']),

      filters () {
        return {
          keywords: this.keywords,
          registration: this.registration,
          status: this.status,
          sort: this.sort
        }
      },

      statusOptions () {
        return [
          { id: 'all', text: 'All' },
          { id: 'pending', text: 'Pending' },
          { id: 'awaiting_approval', text: 'Awaiting Approval' },
          { id: 'part_approved', text: 'Part-Approved' },
          { id: 'resubmit', text: 'Resubmit' }
        ]
      },

      sortByOptions () {
        return [
          { id: 'desc', text: 'Delivery Newest' },
          { id: 'asc', text: 'Delivery Oldest' }
        ]
      }
    },

    methods: {
      ...mapMutations('load', [RESET_LOAD]),
      ...mapMutations('loadCheck', [ADD_LOAD, REMOVE_LOAD]),
      ...mapActions('loadCheck', ['getLoadChecks', 'getLoadChecksForNextPage']),

      /**
       * Remove load if the weighbridge status is approved as it no longer needs checking.
       *
       * @param object load
       *
       * @return void
       */
      removeLoadIfWeighbridgeApproved (load) {
        this[ADD_LOAD](load)

        if (load.weighbridge.status === 'approved') {
          this[REMOVE_LOAD](load)
        }
      },

      /**
       * Debounce updating of keywords so we don't poll API immediately for new loads.
       *
       * @param object event
       *
       * @return Function
       */
      updateKeywords: debounce(function (event) {
        this.keywords = event.target.value
      }, 800),

      /**
       * Debounce updating of keywords so we don't poll API immediately for new loads.
       *
       * @param object event
       *
       * @return Function
       */
      updateRegistration: debounce(function (event) {
        this.registration = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// LoadChecksList.vue?5b07b64c